<template>
  <div style="color: #666;font-size: 14px;">
  </div>
</template>

<script>

export default {
  name: "Xcx",
    data(){
      return{
      }
    },
    methods:{
      geturl(){
          this.request.get("/x-wxuser/v1/getUrl").then((res) => {
              if (res.ok) {
                 // console.log('res',res.data)
                  location.href = res.data
              } else {
                  this.$message.error(res.error.message);
              }
          });
      },
    },
    mounted() {
      this.geturl()
      //  location.href = 'https://wxaurl.cn/UFO20KDuKdl'
    }

}

</script>
